<div
  status
  [attr.size]="size()"
  [ngStyle]="{ '--color': wpStatus.color }">
  <div statusDot></div>
  <span
    statusName
    [ngClass]="labelClasses"
    [pTooltip]="wpStatus.name"
    [tooltipDisabled]="wpStatus.name.length < 8">
    {{ wpStatus.name }}
  </span>
</div>
